import { createSelector } from 'reselect';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { setTrendsMetrics, setFiltersMetrics } from '@store/noc/base/actions';
import {
  supportedMetricsSelector,
  nocTechErrorMetricsFeatureSelector,
} from '@store/common/selectors';
import { rawMetricSelector as trendsMetricSelector } from '@store/noc/trendsData/selectors';
import { rawMetricSelector as filtersMetricSelector } from '@store/noc/filtersData/selectors';
import {
  NOC_EXCLUDE_METRICS,
  METRICS_DEFAULT_ORDER,
  TECH_ERROR_METRICS,
  ERROR_METRICS,
} from '@utils/metrics';

const metricOrder = METRICS_DEFAULT_ORDER[CURRENT_PRODUCT_MODE];
const excludeList = new Set(NOC_EXCLUDE_METRICS);
const techErrorMetric = new Set(TECH_ERROR_METRICS);
const errorMetric = new Set(ERROR_METRICS);

// order metrics
const orderedSupportedMetrics = createSelector(supportedMetricsSelector, (metrics) => {
  return Object.values(metrics).sort(
    (a: any, b: any) => metricOrder.indexOf(a.name) - metricOrder.indexOf(b.name),
  );
});

const formatMetrics = (supportedMetrics, nocTechErrorMetrics) => {
  const excludeMetricList = nocTechErrorMetrics
    ? new Set([...excludeList, ...errorMetric])
    : new Set([...excludeList, ...techErrorMetric]);

  const nocMetrics = {};

  supportedMetrics.forEach((metric: any) => {
    if (excludeMetricList.has(metric.name)) {
      return;
    }
    nocMetrics[metric.name] = metric;
  });
  return {
    metricOptions: nocMetrics,
  };
};

// trends view metric dropdown props
export const trendsProps = {
  setMetrics: setTrendsMetrics,
  metricSelector: createSelector(
    orderedSupportedMetrics,
    trendsMetricSelector,
    nocTechErrorMetricsFeatureSelector,
    (supportedMetrics, selectedMetrics, nocTechMetric) => {
      const { metricOptions } = formatMetrics(supportedMetrics, nocTechMetric);
      return {
        metricOptions,
        selectedMetrics,
      };
    },
  ),
};

// filters view metric dropdown props
export const filtersProps = {
  setMetrics: setFiltersMetrics,
  metricSelector: createSelector(
    orderedSupportedMetrics,
    filtersMetricSelector,
    nocTechErrorMetricsFeatureSelector,
    (supportedMetrics, selectedMetrics, nocTechErrorMetrics) => {
      const { metricOptions } = formatMetrics(supportedMetrics, nocTechErrorMetrics);
      return {
        metricOptions,
        selectedMetrics,
      };
    },
  ),
};

export const selectedTrendsProps = {
  setMetrics: setTrendsMetrics,
  metricSelector: createSelector(trendsMetricSelector, (selectedMetrics) => {
    return selectedMetrics;
  }),
};

// filters view metric dropdown props
export const selectedFiltersProps = {
  setMetrics: setFiltersMetrics,
  metricSelector: createSelector(filtersMetricSelector, (selectedMetrics) => {
    return selectedMetrics;
  }),
};
